import { useCallback } from 'react';
import { useSede } from 'context/SedeContext';
import api from '../api/api';

export const useApi = () => {
  const { addSedeHeaders, addSedeParams, getSedeIdsString } = useSede();

  const apiCall = useCallback(async (method, url, data = null, config = {}) => {
    // Add sede headers to the request
    const configWithSede = addSedeHeaders(config);
    
    // Add sede params to query parameters if it's a GET request
    if (method.toLowerCase() === 'get' && configWithSede.params) {
      configWithSede.params = addSedeParams(configWithSede.params);
    }

    try {
      const response = await api[method](url, data, configWithSede);
      return response;
    } catch (error) {
      console.error(`API ${method.toUpperCase()} error:`, error);
      throw error;
    }
  }, [addSedeHeaders, addSedeParams]);

  const get = useCallback((url, config = {}) => {
    return apiCall('get', url, null, config);
  }, [apiCall]);

  const post = useCallback((url, data, config = {}) => {
    return apiCall('post', url, data, config);
  }, [apiCall]);

  const put = useCallback((url, data, config = {}) => {
    return apiCall('put', url, data, config);
  }, [apiCall]);

  const patch = useCallback((url, data, config = {}) => {
    return apiCall('patch', url, data, config);
  }, [apiCall]);

  const del = useCallback((url, config = {}) => {
    return apiCall('delete', url, null, config);
  }, [apiCall]);

  return {
    get,
    post,
    put,
    patch,
    delete: del,
    sedeIds: getSedeIdsString()
  };
};

export default useApi;
